import moment from "moment";
import { jwtDecode as jwt } from "jwt-decode";

import { baseUrl } from "./APIBaseUrl";
import { saveIntendedRoute } from "./postLoginRedirect";

let token = {};
let refreshTokenResponse;
let refreshTokenFlag = false;
let refreshTokenRefreshedAt;

export const getIdToken = () => {
  token = {
    accessToken: localStorage.getItem("accessToken"),
    refreshToken: localStorage.getItem("refreshToken"),
  };

  return token;
};

// eslint-disable-next-line consistent-return
export const makeRequest = async (opts, loaderFlag, apiType) => {
  token = await getIdToken();
  const headers = {};
  if (opts.contentType) {
    headers["Content-Type"] = opts.contentType;
  }
  const options = {
    ...opts,
    headers,
  };

  if (token != null) {
    options.headers.Authorization = `Bearer ${token.accessToken}`;
  }

  refreshTokenFlag = false;

  const continueRequest = async (accessToken) => {
    options.headers.Authorization = `Bearer ${accessToken}`;
    const response = await fetch(options.path, options);
    let data;
    if (apiType) {
      data = await response.blob();
    } else {
      data = await response.json();
    }

    return {
      ok: response.ok,
      status: response.status,
      payload: data,
    };
  };

  const resolvePromise = () => {
    return new Promise((resolve) => {
      const intervalId = setInterval(async () => {
        if (!refreshTokenFlag) {
          const accessToken = localStorage.getItem("accessToken");

          if (accessToken) {
            clearInterval(intervalId);
            const res = await continueRequest(accessToken);
            resolve(res);
          }
        }
      }, 2000);
    });
  };

  // eslint-disable-next-line no-return-await
  try {
    const response = await fetch(options.path, options);

    let data;
    if (apiType && response.status === 200) {
      data = await response.blob();
    } else {
      data = await response.json();
    }

    // The backend returns 403 for BOTH an expired access token AND a
    // permission-denied request. Only a genuine expired-token 403 should trigger
    // a refresh; treating every 403 as expiry causes an endless refresh storm
    // that eventually logs the user out (PRD-1779). Any other 403 (e.g.
    // permission denied) falls through and is returned to the caller as-is.
    if (!response.ok && response.status == 403 && data?.error?.[0]?.description === "JWT Token Expired") {
      throw new Error(response.status);
    }

    return {
      ok: response.ok,
      status: response.status,
      payload: data,
    };
  } catch (error) {
    if (refreshTokenFlag) {
      const res = await resolvePromise();
      return res;
    }
    if (error.message == 403) {
      if (refreshTokenRefreshedAt && moment().diff(refreshTokenRefreshedAt, "seconds") < 10) {
        const res = await resolvePromise();
        return res;
      }

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.accessToken}`,
        },
        body: JSON.stringify({
          refreshToken: `${token.refreshToken}`,
        }),
      };
      refreshTokenFlag = true;

      refreshTokenResponse = await fetch(`${baseUrl}/refresh`, requestOptions);
      if (refreshTokenResponse.ok && refreshTokenResponse.status == 201) {
        const data = await refreshTokenResponse.json();
        const user = jwt(data.accessToken);

        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("loggedInUser", JSON.stringify(user));
        localStorage.setItem("permissionTable", JSON.stringify({
          permissions: data.permissions || [],
          features: data.features || [],
        }));

        refreshTokenFlag = false;
        refreshTokenRefreshedAt = moment();

        const res = await continueRequest(data.accessToken);
        return res;
      }

      const anonymousKey = localStorage.getItem("anonymousKeyForLD");
      localStorage.clear();
      if (anonymousKey && anonymousKey !== "null") localStorage.setItem("anonymousKeyForLD", anonymousKey);

      saveIntendedRoute(`${window.location.pathname}${window.location.search}${window.location.hash}`);
      window.location.replace("/");
    } else if (error.message == 401) {
      const anonymousKey = localStorage.getItem("anonymousKeyForLD");
      localStorage.clear();
      if (anonymousKey && anonymousKey !== "null") localStorage.setItem("anonymousKeyForLD", anonymousKey);

      saveIntendedRoute(`${window.location.pathname}${window.location.search}${window.location.hash}`);
      window.location.replace("/");
    } else {
      return error;
    }
  }
};
